import { createReducer } from '../../../utilities';
import {
    SUCCESS_FETCH_ALERTS_BY_USER
} from "../../../../actions/entities/user";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return { ...data };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_ALERTS_BY_USER]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/support/user/alerts.js